import React, { useState } from "react";

export default function Tabs({ tabs = [], defaultKey }) {
    const [activeKey, setActiveKey] = useState(defaultKey || tabs[0]?.key);
    const activeTab = tabs.find((t) => t.key === activeKey);

    return (
        <div className="mt-4">
            {/* Tab Header */}
            <ul className="nav nav-tabs border-0">
                {tabs.map((tab) => (
                    <li className="nav-item" key={tab.key}>
                        <button
                            className={`nav-link ${activeKey === tab.key ? "active" : ""}`}
                            style={{
                                border: "none",
                                background: "none",
                                color: activeKey === tab.key ? "#000" : "#777",
                                borderBottom: activeKey === tab.key ? "2px solid #000" : "2px solid transparent",
                                fontWeight: activeKey === tab.key ? "600" : "400",
                                transition: "color 0.2s, border-bottom 0.2s",
                            }}
                            onClick={() => setActiveKey(tab.key)}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>

            {/* Tab Content */}
            <div className="tab-content mt-3">
                <div className="tab-pane active">{activeTab?.component}</div>
            </div>
        </div>
    );
}
